import React, { createContext, useState, useRef, useEffect } from 'react';

export const VideoPlayerContext = createContext();

export const VideoPlayerProvider = ({ children }) => {
  const [isAttached, setIsAttached] = useState(false); // True if attached to VisualRadio
  const [isClosed, setIsClosed] = useState(false); // True if user closed the floating player
  const [isPlaying, setIsPlaying] = useState(false); // True if video is playing

  const playerRef = useRef(null); // VideoJS instance
  const defaultContainerRef = useRef(null); // The floating container in App
  
  // We create a persistent DOM element for the player.
  // This element will be manually moved around the DOM.
  const [playerUI] = useState(() => {
    const div = document.createElement('div');
    // div.style.width = '100%';
    // div.style.height = '100%';
    return div;
  });

  return (
    <VideoPlayerContext.Provider value={{
      isAttached,
      setIsAttached,
      isClosed,
      setIsClosed,
      isPlaying,
      setIsPlaying,
      playerRef,
      defaultContainerRef,
      playerUI // Expose the DOM node
    }}>
      {children}
    </VideoPlayerContext.Provider>
  );
};
